<template>
    <div class="page-home-carousel">
        <el-carousel v-if="show_flag" :interval="5000" arrow="always" height="757px" @change="imgAnimation">
            <el-carousel-item v-for="(slider,index) in sliders" class="slider-item"
                              :style="'background-image:url('+ slider.bg_pic_url +')'" >
                <div class="item-content">
                <div class="item-img" :class="'item-img' + (index+1)"
                :style="'background-image:url(' + slider.person_pic_url + ')'"></div>
                <div class="item-desc" :class="'item-desc' + (index+1)">
                <img class="game-logo" :class="'game-logo' + (index+1) "
                :src="slider.logo_pic_url">
                <h1 class="game-title">{{ slider.big_title }}</h1>

                <div class="orange-line"></div>
                <p class="game-desc"> {{ slider.tips }}</p>
                <a :href="slider.detail_href" target="_blank" class="detail-link">{{ $t('checkDetail') }}</a>
                </div>
                </div>
            </el-carousel-item>
        </el-carousel>

    </div>
</template>

<script>

    import md5 from 'blueimp-md5'
    import globals from '../../config/global'

    export default {
        data: function () {
            return {
                sliders:[],
                show_flag:false
            }
        },
        created() {
            if (globals.methods.getStorageItem('carouselData')) {
                this.show_flag = true
                this.sliders = JSON.parse(globals.methods.getStorageItem('carouselData'));
                return
            }
            let timeStamp = Date.parse(new Date())
            let sign = md5(timeStamp)
            let that = this

            let extraParam = '&platform=2'//1英卓，2萌果
            if(globals.isTest){//测试环境会获取未审核的内容
                extraParam += '&isTest=1'
            }
            this.$http.get(globals.enjoyUrl + 'enjoysiteapi/getcarousel?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(
                function (response) {
                    that.sliders = response.data
                    that.show_flag = true
                    globals.methods.setStorageItem('carouselData',that.sliders)
                });


        },
        methods: {
            imgAnimation(sliderIndex) {
                let index = sliderIndex + 1;
                $('.item-img').hide();
                $('.item-desc').hide();

                setTimeout(() => {
                    $('.item-img' + index).fadeIn();
                    setTimeout(() => {
                        $('.item-desc' + index).fadeIn();
                    }, 600);
                }, 600);
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib.scss";

    .page-home-carousel {
        .el-carousel {
            .el-carousel__container {
                .el-carousel__item {
                    opacity: 0 !important;
                    transition: all .2s ease-out !important;
                    transform: none !important;
                    background-repeat: no-repeat;
                    background-size: 100% 757px;
                }
                .is-active {
                    opacity: 1 !important;
                    transition: all .2s ease-in !important;
                    transform: none !important;
                }
            }
        }
    }

    .item-content {
        width: 1080px;
        height: 757px;
        margin: 0 auto;
        position: relative;
        .item-img {
            position: absolute;
            right: -270px;
            z-index: 9;
            display: none;
            background-repeat: no-repeat;
            background-position: top center;
            background-size: 700px 734px;
            width: 700px;
            height: 734px;
        }

    }



    .item-desc {
        height: 500px;
        position: absolute;
        z-index: 10;
        top: 65px;
        left: 30px;
        h1.game-title {
            color: #fff;
            text-shadow: 0 0 0.3em #ffbb81,
            -0 -0 0.3em #ffbb81;
            width:600px;
            word-wrap: break-word;
            word-break: break-all;
        }
        p.game-desc {
            color: #fff;
            text-shadow: 0 0 0.5em #ffbb81,
            -0 -0 0.5em #ffbb81;
        }
        .game-logo {
            height: 150px;
        }
        .game-title {
            color: #252525;
            font-size: 42px;
        }
        .orange-line {
            height: 2px;
            background: $orange-color;
            margin-top: 5px;
        }
        .game-desc {
            margin: 10px 10px 0 0;
            color: #333333;
            font-size: 16px;
            line-height: 28px;
            width: 493px;
        }
        .detail-link {
            display: block;
            width: 126px;
            height: 42px;
            background: #ffaa23;
            color: #fff;
            font-size: 16px;
            @include flex-row-center;
            text-decoration: none;
            cursor: pointer;
            margin-top: 40px;
            border: 1px solid #fff;
            box-sizing: border-box;
        }
    }
</style>



// WEBPACK FOOTER //
// Carousel.vue?0806e930